import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { RequestTypes } from '../requestTypes'
import { companyKeys } from '../companyKeys'

interface UploadCompaniesTemplateResponse {
  downloadUrl: string
  downloadDirectUrl: string
  fileKey: string
}

export const useUploadCompaniesTemplate = (
  options?: UseMutationOptions<
    UploadCompaniesTemplateResponse,
    RequestErrorType,
    RequestTypes['uploadCompaniesTemplate']
  >,
) => {
  return useMutation({
    ...companyKeys.uploadCompaniesTemplate,
    ...options,
  })
}
